import { render, staticRenderFns } from "./EditTransaction.vue?vue&type=template&id=75c95252&scoped=true&"
import script from "./EditTransaction.vue?vue&type=script&lang=js&"
export * from "./EditTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c95252",
  null
  
)

export default component.exports